import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (notification) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      ...notification,
      open: true,
    };
    setNotifications(prev => [...prev, newNotification]);
    return id;
  };
  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  const showSuccess = (message, title = 'Успех', options = {}) => {
    return addNotification({
      type: 'success',
      title,
      message,
      options,
      severity: 'success',
    });
  };
  const showError = (message, title = 'Ошибка', options = {}) => {
    return addNotification({
      type: 'error',
      title,
      message,
      options,
      severity: 'error',
    });
  };
  const showWarning = (message, title = 'Внимание', options = {}) => {
    return addNotification({
      type: 'warning',
      title,
      message,
      options,
      severity: 'warning',
    });
  };
  const showInfo = (message, title = 'Информация', options = {}) => {
    return addNotification({
      type: 'info',
      title,
      message,
      options,
      severity: 'info',
    });
  };

  const value = {
    addNotification,
    removeNotification,
    clearNotifications,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={notification.open}
          autoHideDuration={notification.autoHideDuration || 5000}
          onClose={() => removeNotification(notification.id)}
          sx={{
            paddingTop: notification?.options?.paddingTop || "0px",
            pointerEvents: 'none',
          }}
          anchorOrigin={{
            vertical: notification?.options?.vertical || 'top',
            horizontal: notification?.options?.horizontal || 'right'
        }}
        >
          <Alert
            onClose={() => removeNotification(notification.id)}
            onClick={() => removeNotification(notification.id)}
            severity={notification.severity}
            variant="filled"
            sx={{ width: '100%', pointerEvents: 'auto', cursor: 'pointer' }}
          >
            <strong>{notification.title}</strong>
            {notification.message && (
              <div style={{ marginTop: '4px' }}>{notification.message}</div>
            )}
          </Alert>
        </Snackbar>
      ))}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
